import React from 'react';
import PropTypes from 'prop-types';

class ImageViewer extends React.Component {
  render() {

    if(!this.props.show) {
      return null;
    }

    const backdropStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundImage: `url('http://redpithemes.com/Documentation/assets/img/page_bg/page_bg_blur02.jpg')`,
      zIndex:99,
      width:'100%',
      height:'100%',
      overflow:'scroll',
    };

    return (
      <div id="imageViewer" className="backdrop" style={backdropStyle} onClick={this.props.onClose}>
        <div className="modal-dialog">
          <div className="modal-content">
              <div className="modal-header">
                <button onClick={this.props.onClose} className="close">&times;</button>
                <h4 className="modal-title"><code>{this.props.title}</code></h4>
              </div>
              <div className="modal-body">
                <img src={this.props.imgHolder} alt="TUPICNOW" className="img-responsive"/>
              </div>
            </div>
        </div>
      </div>
    );
  }
}

ImageViewer.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default ImageViewer;



// WEBPACK FOOTER //
// /src/components/ImageViewer.js